import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Typography,
    Button,
    CircularProgress,
    ToggleButton,
    ToggleButtonGroup,
} from '@mui/material';
import CustomMonthDatePicker from '../../Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker';

const TransferImportDialog = ({
    open,
    direction = 'ltr',
    isProcessing = false,
    reportingDate,
    registrationDate,
    onReportingDateChange,
    onRegistrationDateChange,
    paymentMethodType,
    onPaymentMethodChange,
    paymentMethodOptions = [],
    paymentAcceptanceType,
    onPaymentAcceptanceTypeChange,
    paymentAcceptanceOptions = [],
    onCancel,
    onConfirm,
    t,
}) => {
    const handlePaymentMethodChange = (_, value) => {
        if (!value) return;
        onPaymentMethodChange(value);
    };

    const handlePaymentAcceptanceChange = (_, value) => {
        if (!value) return;
        onPaymentAcceptanceTypeChange(value);
    };

    return (
        <Dialog
            open={open}
            onClose={isProcessing ? undefined : onCancel}
            maxWidth="xs"
            fullWidth
            dir={direction}
        >
            <DialogTitle>
                {`${t('MonthReportDate')} & ${t('RegistrationMonthDate')}`}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            {t('MonthReportDate')}
                        </Typography>
                        <CustomMonthDatePicker
                            date={reportingDate}
                            onDateChange={onReportingDateChange}
                            height="40px"
                            disabled={isProcessing}
                        />
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            {t('RegistrationMonthDate')}
                        </Typography>
                        <CustomMonthDatePicker
                            date={registrationDate}
                            onDateChange={onRegistrationDateChange}
                            height="40px"
                            disabled={isProcessing}
                        />
                    </Box>
                    <Box dir={direction}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            {t('SelectPaymentMethod')}
                        </Typography>
                        <ToggleButtonGroup
                            value={paymentMethodType}
                            exclusive
                            onChange={handlePaymentMethodChange}
                            disabled={isProcessing}
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                            }}
                        >
                            {paymentMethodOptions.map(option => (
                                <ToggleButton
                                    key={option.value}
                                    value={option.value}
                                    sx={{
                                       
                                        minWidth: 110,
                                        borderRadius: 2,
                                        textTransform: 'none',
                                        fontSize: '0.85rem',
                                    }}
                                    size="small"
                                >
                                    {option.label}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            {t('PaymentType')}
                        </Typography>
                        <ToggleButtonGroup
                            value={paymentAcceptanceType}
                            exclusive
                            onChange={handlePaymentAcceptanceChange}
                            disabled={isProcessing}
                            sx={{
                                display: 'flex',
                                gap: 1,
                            }}
                        >
                            {paymentAcceptanceOptions.map(option => (
                                <ToggleButton
                                    key={option.value}
                                    value={option.value}
                                    sx={{
                                        flex: 1,
                                        borderRadius: 2,
                                        textTransform: 'none',
                                        fontSize: '0.85rem',
                                    }}
                                    size="small"
                                >
                                    {option.label}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
                <Button
                    variant="outlined"
                    onClick={onCancel}
                    disabled={isProcessing}
                >
                    {t('cancel')}
                </Button>
                <Button
                    variant="contained"
                    onClick={onConfirm}
                    disabled={isProcessing}
                >
                    {isProcessing ? (
                        <CircularProgress size={20} color="inherit" />
                    ) : (
                        t('Confirm')
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TransferImportDialog;

